import { render, staticRenderFns } from "./gold.vue?vue&type=template&id=1c15954b&scoped=true&"
import script from "./gold.vue?vue&type=script&lang=js&"
export * from "./gold.vue?vue&type=script&lang=js&"
import style0 from "./gold.vue?vue&type=style&index=0&id=1c15954b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c15954b",
  null
  
)

export default component.exports